// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../variables.css\"","breakpoint":"768px","credits-button":"CreditsButton_credits-button__WBxGt"};